import { bizmatesApi } from '@/utils/bizmatesApi';
import qs from 'qs';

export default {
  namespaced: true,
  state() {
    return {
      translationList: null,
      typeOfWordsList: null,
      programTypeList: null,
      htmlLessonList: null,
      updatedVocabulary: '',
      createdVocabulary: ''
    };
  },
  mutations: {
    setTranslationList(state, payload) {
      state.translationList = payload;
    },
    setTypeOfWordsList(state, payload) {
      state.typeOfWordsList = payload;
    },
    setProgramTypeList(state, payload) {
      state.programTypeList = payload;
    },
    setHtmlLessonList(state, payload) {
      state.htmlLessonList = payload;
    },
    setUpdatedVocabulary(state, payload) {
      state.updatedVocabulary = payload;
    },
    setCreatedVocabulary(state, payload) {
      state.createdVocabulary = payload;
    }
  },
  actions: {
    async getTranslationList({ commit }, params) {
      await bizmatesApi.get('vocabularymanagement/list', { params }, response => {
        commit('setTranslationList', response.data.data);
      });
    },
    async getTypeOfWordsList({ commit }) {
      await bizmatesApi.get('vocabularymanagement/typesOfWords', {}, response => {
        commit('setTypeOfWordsList', response.data.data);
      });
    },
    async getProgramTypeList({ commit }) {
      await bizmatesApi.get('vocabularymanagement/programs', {}, response => {
        commit('setProgramTypeList', response.data.data);
      });
    },
    async getHtmlLessonList({ commit }) {
      await bizmatesApi.get('vocabularymanagement/lessons', {}, response => {
        commit('setHtmlLessonList', response.data.data);
      });
    },
    async updateVocabulary({ commit }, params) {
      await bizmatesApi.post('vocabularymanagement/update', qs.stringify(params), {}, response => {
        commit('setUpdatedVocabulary', response.data.data);
      });
    },
    async createVocabulary({ commit }, params) {
      await bizmatesApi.post('vocabularymanagement/store', qs.stringify(params), {}, response => {
        commit('setCreatedVocabulary', response.data.data);
      });
    }
  }
};
